const colorArr = [
    { name: "A", color: "#ef4581" },
    { name: "B", color: "#4593a8" },
    { name: "C", color: "#00ca7a" },
    { name: "D", color: "#927394" },
    { name: "E", color: "#5a767f" },
    { name: "F", color: "#969695" },
    { name: "G", color: "#eb1761" },
    { name: "H", color: "#177892" },
    { name: "I", color: "#00a262" },
    { name: "J", color: "#6e4571" },
    { name: "K", color: "#31545f" },
    { name: "L", color: "#7c7c7b" },
    { name: "M", color: "#d4004b" },
    { name: "N", color: "#00627c" },
    { name: "O", color: "#008e56" },
    { name: "P", color: "#4a174d" },
    { name: "Q", color: "#1b3d49" },
    { name: "R", color: "#656564" },
    { name: "S", color: "#aa003c" },
    { name: "T", color: "#004e63" },
    { name: "U", color: "#005131" },
    { name: "V", color: "#330037" },
    { name: "W", color: "#16313b" },
    { name: "X", color: "#515151" },
    { name: "Y", color: "#80002d" },
    { name: "Z", color: "#003b4b" },
    { name: "0", color: "#45e7a7" },
    { name: "1", color: "#29002c" },
    { name: "2", color: "#10252c" },
    { name: "3", color: "#474746" },
    { name: "4", color: "#55001e" },
    { name: "5", color: "#002732" },
    { name: "6", color: "#17e191" },
    { name: "7", color: "#1f0021" },
    { name: "8", color: "#0b191e" },
    { name: "9", color: "#292928" },
]

function setColor(data) {

    let filterColor = colorArr.filter((item, i) => { return item.name == data });
    if (filterColor && filterColor.length !== 0) {
        return filterColor[0].color;
    } else {
        return "#aaaaaa";
    }
};

export default setColor;